import Player from '@vimeo/player';

const VimeoControls = {
    init() {
        var vimeoButton = document.querySelectorAll('[data-vimeo-id]');

        vimeoButton.forEach((btn) => {
            btn.addEventListener('click', () => {
                var vimeoId = btn.dataset.vimeoId;
                var iframe = document.getElementById(vimeoId);
                var player = new Player(iframe);

                var vimeoButtonType = btn.dataset.vimeoButtonType;
            
                vimeoButtonType == 'play' ? player.pause() : player.play();
                vimeoButtonType == 'play' ? btn.dataset.vimeoButtonType = 'pause' : btn.dataset.vimeoButtonType = 'play';
            });
        })
    }
};

export default VimeoControls;
